class PortForwardingDatatable
{
    constructor() {
        this.datatable = null;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.el = "#port-forward-datatable";
        this.editPortForward();
        this.deletePortForward();
    }

    init(gatewayID) {
        this.gatewayID = gatewayID;
        let thisClass = this;
        if(this.datatable){
            this.datatable.destroy();
        }
        const datatable = $(this.el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            scrollX: true,
            ajax: {
                url: '/gateways/?do=getGatewayPortForward',
                type: 'POST',
                data: {
                    organizationID: thisClass.organizationID,
                    gatewayID: gatewayID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=port-forward-datatable_length]').select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $('#gateway_port_forward_modal')
                });
            },
            columns: [
                {
                    data: 'vpnUserName',
                    title: 'Team Member / Local IP',
                    sortable: true,
                    className: 'min-w-150px',
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row['member']).generateTableMember();
                    }
                },
                {
                    data: 'serviceName',
                    title: 'Service Name',
                    className: 'min-w-100px',
                    sortable: true,
                    render: function (data, type, row) {
                        return '<span data-service-name="'+row['name']+'">'+row['name']+'</span>';
                    }
                },
                {
                    data: 'publicPort',
                    title: 'Public Port / Range',
                    className: 'min-w-100px',
                    sortable: true,
                    render: function (data, type, row) {
                        return row['publicPort'];
                    }
                },
                {
                    data: 'localPort',
                    title: 'Local Port / Range',
                    className: 'min-w-100px',
                    sortable: true,
                    render: function (data, type, row) {
                        return row['localPort'];
                    }
                },
                {
                    data: 'protocol',
                    title: 'Protocol',
                    sortable: true,
                    render: function(data, type, row) {
                        return row["protocol"].toUpperCase();
                    }
                },
                {
                    data: 'uuid',
                    title: 'Actions',
                    sortable: false,
                    render: function(data, type, row) {
                        let html = '<div class="datatable-action min-w-2" id="' + row['uuid'] + '">';
                        html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-port-forward" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                            '           <span class="svg-icon svg-icon-3">' +
                            '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                            '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                            '               </svg>' +
                            '           </span>' +
                            '       </div>';
                        html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary remove-pf cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Remove">'+
                            '                   <span class="svg-icon svg-icon-3">' +
                            '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                            '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                            '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                            '                       </svg>' +
                            '                   </span>' +
                            '               </div>';
                        return html;
                    }
                }
            ]

        }).on('draw', function() {
            if(datatable.page.info().recordsTotal === 0){
                $('#port-forward-datatable_wrapper').hide();
                $('#port-forward-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#port-forward-datatable_wrapper').show();
                $('#port-forward-datatable_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
            }
        });
        this.datatable = datatable;
        return datatable;
    }

    editPortForward() {
        let thisClass = this;
        $(document).on('click','.edit-port-forward',function() {
            let portForwardID = $(this).parent()[0].id;

            let gatewayPortForwardModal = document.getElementById('gateway_port_forward_modal');
            new ModalLoading();
            bootstrap.Modal.getInstance(gatewayPortForwardModal).hide();
            naja.makeRequest('GET', '/gateways/?do=GetPortForwardInfo', {
                'gatewayID': thisClass.gatewayID,
                'organizationID': thisClass.organizationID,
                'portForwardID': portForwardID
            }, {
                history: false // Prevent URL changes in browser history
            }).then(() => {
                gatewayActions.returnToPortForwardModal('edit-port','edit-port-forward-modal');
                gatewayActions.editPortForwardValidation(portForwardID);
                gatewayActions.initCreatePortForwardSelect2('#frm-generalForms-editPortForwardForm-editPortForwardForm', '#edit-port-forward-modal');
                $('#frm-generalForms-editPortForwardForm-editPortForwardForm input[name=PortForwardID]').val(portForwardID);
                $.nette.load();
                KTScroll.createInstances();

                new ModalLoading(document.getElementById('edit-port-forward-modal'));
            }).catch(error => {
                new ModalLoading(gatewayPortForwardModal);
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
            });
        });
    }

    deletePortForward() {
        let thisClass = this;
        $(document).on('click','.remove-pf',function() {
            let portForwardID = $(this).parent().attr('id');
            let memberName = $(this).closest('tr').find('[data-member-name]').attr('data-member-name');
            let serviceName = $(this).closest('tr').find('span[data-service-name]').attr('data-service-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Port Forward`+(serviceName !== undefined ? ` with service name <b>`+serviceName+`</b>` : `` )+(memberName !== undefined ? ` for <b>`+memberName+`</b>` : `` )+ ` is going to be completely deleted!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/gateways?do=removePortForwarding&organizationID='+thisClass.organizationID+'&portForwardID='+portForwardID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value === 'deleted') {
                        toastr.success('Port Forward has been deleted');
                        $('#port-forward-datatable').DataTable().draw();
                    }
                }
            });
        });
    }

}

window.PortForwardingDatatable = PortForwardingDatatable;